import React from "react";
import { Stack, Box } from "@mui/material";
import TimePickerField from "./components/TimePickerField";
import { TIME_PICKER_MODES, TIME_PICKER_STYLE } from "./HyroTimePicker.consts";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Tooltip from "@hyro-components/Tooltip";
import useHyroTimerPicker from "./HyroTimerPicker.hook.jsx";
dayjs.extend(customParseFormat);

const HyroTimePicker = ({
  mode = TIME_PICKER_MODES.SINGLE,
  layoutStyle = TIME_PICKER_STYLE.TALL,
  value,
  onChange,
  isRangePersistent = true,
  disabled = false,
  error,
  helperText,
  fromKeyword = "from",
  toKeyword = "to",
  fromPlaceholder = "From",
  toPlaceholder = "To",
  testId = "hyro-time-picker",
  timeConstraints,
  ...props
}) => {
  const {
    startTime,
    endTime,
    handleFromChange,
    handleToChange,
    getEndTimeConstraints
  } = useHyroTimerPicker({
    value,
    onChange,
    isRangePersistent,
    fromKeyword,
    toKeyword,
    timeConstraints
  });

  if (mode === TIME_PICKER_MODES.SINGLE) {
    return (
      <TimePickerField
        value={dayjs(value, "HH:mm")}
        layoutStyle={layoutStyle}
        onChange={onChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        testId={testId}
        timeConstraints={timeConstraints?.from}
        {...props}
      />
    );
  }

  return <Stack direction="row" gap={1.5} alignItems="center">
    <Tooltip title={error ? "Invalid time range" : ""}>
      <TimePickerField
        value={startTime ? dayjs(startTime, "HH:mm") : null}
        layoutStyle={layoutStyle}
        onChange={handleFromChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        placeholder={fromPlaceholder}
        testId={`${testId}-${fromKeyword}`}
        timeConstraints={timeConstraints?.from}
        {...props}
      />
    </Tooltip>
    <Box sx={{ width: "8px", height: "1.2px", backgroundColor: theme => theme.palette.text[700] }} />
    <Tooltip title={error ? "Invalid time range" : ""}>
      <TimePickerField
        value={endTime ? dayjs(endTime, "HH:mm") : null}
        layoutStyle={layoutStyle}
        onChange={handleToChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        placeholder={toPlaceholder}
        fromTime={isRangePersistent ? startTime : null}
        testId={`${testId}-${toKeyword}`}
        timeConstraints={getEndTimeConstraints()}
        {...props}
      />
    </Tooltip>
  </Stack>;
};

export default HyroTimePicker;
